//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { slavicPlural, filterData } from '../../../../../components/helpers.js'
import {
  REQUEST_PRIORITIES,
  REQUEST_TEMPLATES,
  loadRequestTypeConfiguration,
  addConfigurableRequestProperties,
  computeCloseConditionTime,
  loadObjectsActiveRequests,
  getRequestRoles
} from '../../../../../forms/Request/Request.js'
import { filterRequestTypesByUserAccess, filterRequestTypesByServiceObjectType } from '../../../../../forms/Request/RequestType.js'
import { getServiceObjectsCheckResult } from '../../../../../forms/Request/RequestServiceObjectsCheck.js'
import { axiosGet, axiosPost } from '../../../../../axios/axios.js'
import { mapGetters } from 'vuex'
import DispatcherTasksTabSelectExecutor from './DispatcherTasksTabSelectExecutor.vue'
import RequestAutoPriority from '../../../../../forms/Request/RequestAutoPriority.vue'
import RequestForkliftTruckField from '../../../../../forms/Request/RequestForkliftTruckField.vue'
import RequestDescriptionField from '../../../../../forms/Request/RequestDescriptionField.vue'
import DateTimeField from '../../../../../components/Field/DateTimeField.vue'

import { EventBus } from '../../../../../EventBus/EventBus.js'
import RequestObjectActiveRequests from '../../../../../forms/Request/RequestObjectActiveRequests.vue'
import RequestWorkTypes from '../../../../../forms/Request/RequestWorkTypes.vue'
import RequestNoVISTypeBanner from '../../../../../forms/Request/RequestNoVISTypeBanner.vue'

export default {
  components: {
    DispatcherTasksTabSelectExecutor,
    RequestAutoPriority,
    RequestForkliftTruckField,
    RequestDescriptionField,
    DateTimeField,
    RequestWorkTypes,
    RequestNoVISTypeBanner
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    selectedServiceObjectsIds: {
      type: Array,
      default () {
        return []
      }
    },
    template: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      loadingProjects: false,
      loadingActiveRequests: false,
      request: this.getNewRequest(),
      requestInitial: this.getNewRequest(),
      requestPriorities: REQUEST_PRIORITIES,

      createdRequests: [],
      selectExecutorOpened: false,
      serviceObjectType: null,

      availableRequestTypes: [],
      availableWorkTypes: [],
      filteredAvailableWorkTypes: [],
      projectsOptions: [],

      activeRequests: [],

      searchText: '',
      slavicPlural: slavicPlural,

      expandedWorks: true
    }
  },
  computed: {
    ...mapGetters({
      requestTypes: 'getRequestTypes',
      workTypes: 'getWorkTypes',
      requestSources: 'getRequestSources',
      workAreas: 'getWorkAreas'
    }),
    requestFormConfiguration: function () {
      // const user = this.$store.getters.getUser
      return {
        projectAutoSubstitution: this.roleRestrictedDispatcher,
        multipleServiceObjectsProjectsAccess: this.roleRestrictedDispatcher
      }
    },
    createRequestsAvailable: function () {
      return this.request.requestType !== null &&
             this.request.requestPriority !== null &&
             this.request.autoAssign !== null &&
             this.request.requestSource !== null
    },
    actionLabel: function () {
      return this.selectedServiceObjectsIds.length > 1 ? 'Создать заявки' : 'Создать заявку'
    },
    autoAssignOptions: function () {
      if (this.selectedServiceObjectsIds.length > 1) {
        return [
          { value: true, name: 'Заявки участвуют в автоназначении' },
          { value: false, name: 'Заявки не участвуют в автоназначении' }
        ]
      }
      return [
        { value: true, name: 'Заявка участвует в автоназначении' },
        { value: false, name: 'Заявка не участвует в автоназначении' }
      ]
    },
    autoAssignBrigadeWorkTypesAvailable: function () {
      return !!this.request.autoAssign && this.request.selectedWorkTypesIds.length !== 0
    },
    roleExternalDispatcher: function () {
      const user = this.$store.getters.getUser
      return !!(user.employee && user.employee.external && (user.hasRoleStrict('dispatcher') || user.hasRoleStrict('externalDispatcher')))
    },
    roleRestrictedDispatcher: function () {
      const user = this.$store.getters.getUser
      return user.restrictedAccess // TODO
    },
    roleRestrictedOrExternalDispatcher: function () {
      return this.roleExternalDispatcher || this.roleRestrictedDispatcher
    },
    requestRoles: function () {
      const user = this.$store.getters.getUser
      return getRequestRoles(this.request, user, 'createRequestCard')
    }
  },
  watch: {
    opened: function (opened) {
      if (opened) {
        this.checkServiceObjects()
        this.loadActiveRequests()
      } else {
        this.resetParameters()
      }
    },
    autoAssignBrigadeWorkTypesAvailable: function (value) {
      if (!value) {
        this.request.autoAssignBrigadeWorkTypes = false
      }
    },
    selectedServiceObjectsIds: function (value) {
      this.request = this.getNewRequest()
    },
    'request.requestType': function () {
      const requestTypeId = this.request.requestType

      const requestType = this.availableRequestTypes.find(requestType => requestType.id === requestTypeId)
      if (!this.roleRestrictedOrExternalDispatcher) {
        computeCloseConditionTime(requestType, this.request, this)
      }

      loadRequestTypeConfiguration(requestTypeId, this)
        .then(configuration => {
          this.request.setRawConfiguration(configuration)

          // // const requestType = this.request.requestType
          // const descriptionOptions = this.request._configuration.breakageTypes || null
          // this.setDescriptionOptions(descriptionOptions)
        })

      if (this.roleRestrictedOrExternalDispatcher) { // TODO 9477 refactor - см. RequestAutoPriority.vue
        if (requestTypeId) {
          let url = '/service/delta/request/computePriority?typeId=' + requestTypeId

          if (this.request.serviceObjectId) {
            url += '&serviceObjectId=' + this.request.serviceObjectId
          }
          if (this.request.priorityCondition) {
            url += '&conditionId=' + this.request.priorityCondition
          }
          if (this.request.requestSourceId) {
            url += '&sourceId=' + this.request.requestSourceId
          }
          if (this.request.serviceObjectPriority) {
            url += '&serviceObjectPriority=' + this.request.serviceObjectPriority
          }

          axiosGet({
            url: url,
            onSuccess: response => {
              this.$q.notify({
                type: 'positive',
                message: 'Автоматическое вычисление приоритета заявки',
                progress: true,
                timeout: 3000
              })
              this.request.requestPriority = Number(response.data.priority)
            },
            onFailure: 'Ошибка вычисления приоритета заявки'
          })
        } else {
          this.request.requestPriority = null
        }
      }
    },
    'request.workTypes': {
      handler: function (newWorkTypes) {
        this.request.selectedWorkTypesIds = newWorkTypes.map(wT => wT.id)
      },
      deep: true
    }
  },
  methods: {
    getNewRequest: function () {
      const request = {
        project: null,
        description: '', // !!! -> applicantDescription
        autoAssign: null, // false
        requestType: null, // !!! id -> object
        breakageTypeKey: null,
        requestPriority: null,
        requestSource: null,
        serviceObjectId: this.selectedServiceObjectsIds.length === 1 ? this.selectedServiceObjectsIds[0] : null,
        get requestSourceId () {
          return (this.requestSource && this.requestSource.id) || null
        },
        selectedWorkTypesIds: [], // !!!
        workTypes: [], // !!!
        workPackages: [], // !!!
        redirectWorkArea: null, // !!!
        autoAssignBrigadeWorkTypes: false, // !!! - не совместимо
        forkliftTruckRequired: false,
        requestForkliftTruck: null,
        closeConditionTime: null
      }

      const user = this.$store.getters.getUser
      addConfigurableRequestProperties(request, null, user)
      return request
    },
    onSearch: function () {
      this.filteredAvailableWorkTypes = filterData(this.availableWorkTypes, this.searchText, ['name'])
    },
    onClear: function () {
      this.searchText = ''
      this.filteredAvailableWorkTypes = this.availableWorkTypes
    },
    checkServiceObjects: function () {
      getServiceObjectsCheckResult.call(this, this.selectedServiceObjectsIds, true) // before creation
        .then(result => {
          if (result.continueAction) {
            this.serviceObjectType = result.serviceObjectType
            if (this.serviceObjectType === 'transportDetector') {
              this.request.forkliftTruckRequired = true
            }

            this.prepareRequestSources()
            this.prepareRequestTypes()
            this.prepareWorkTypes()
            this.readRequestTemplate()
            this.prepareProjectsSelection()
            this.prepareDescription()

            if (this.roleRestrictedOrExternalDispatcher) {
              this.request.autoAssign = false
            }
          } else {
            this.onClose()
          }
        })
    },
    readRequestTemplate: function () {
      const template = REQUEST_TEMPLATES[this.template]
      if (template) {
        Object.keys(this.request).forEach(key => {
          if (Object.keys(template).includes(key)) {
            if (key === 'requestType') {
              this.request[key] = this.requestTypes.find(type => type.name === template[key]).id
            } else {
              this.request[key] = template[key]
            }
          }
        })
      }
    },
    prepareRequestSources: function () {
      const user = this.$store.getters.getUser
      let defaultRequestSource = user.employee && user.employee.defaultRequestSource || null
      if (!defaultRequestSource) {
        defaultRequestSource = this.requestSources.find(o => o.key === 'deltaSDPEmployee') || null
      }
      this.request.requestSource = defaultRequestSource // !!!
    },
    prepareRequestTypes: function () {
      const currentRequestTypeId = this.request.requestType
      const currentServiceObjectTypeKey = this.serviceObjectType

      const requestTypes = this.requestTypes

      // Фильтруем по доступу
      const user = this.$store.getters.getUser
      let availableRequestTypes = filterRequestTypesByUserAccess(requestTypes, user, currentRequestTypeId)
      // Фильтруем по типу объекта
      availableRequestTypes = filterRequestTypesByServiceObjectType(availableRequestTypes, currentServiceObjectTypeKey, currentRequestTypeId)

      this.availableRequestTypes = availableRequestTypes
      if (this.availableRequestTypes.length === 1 && currentRequestTypeId == null) {
        this.request.requestType = this.availableRequestTypes[0].id
      }
    },
    prepareWorkTypes: function () {
      const currentWorkTypesIds = this.request.selectedWorkTypesIds ? new Set(this.request.selectedWorkTypesIds) : new Set()
      const currentServiceObjectTypeKey = this.serviceObjectType

      this.availableWorkTypes = this.workTypes.filter(workType => {
        return (currentWorkTypesIds.has(workType.id) || //
          (!workType.notMatch && (workType.serviceObjectTypes.length === 0 || workType.serviceObjectTypes.find(typeKey => typeKey === currentServiceObjectTypeKey))))
      })
      this.filteredAvailableWorkTypes = this.availableWorkTypes
    },
    prepareProjectsSelection: function () {
      let promise = null
      if (this.selectedServiceObjectsIds.length === 1) {
        const urlParams = new URLSearchParams()
        urlParams.set('id', this.selectedServiceObjectsIds[0])
        urlParams.set('checkAccess', true)

        this.loadingProjects = true
        promise = axiosGet({
          url: 'service/delta/serviceobject/serviceObjectProjects?' + urlParams.toString(),
          onSuccess: (response) => response.data.result,
          throws: true
        })
      } else if (this.requestFormConfiguration.multipleServiceObjectsProjectsAccess) {
        const serviceObjectsIds = this.selectedServiceObjectsIds

        const bodyFormData = new FormData()
        bodyFormData.set('ids', serviceObjectsIds.join(','))
        bodyFormData.set('checkAccess', true)

        this.loadingProjects = true
        promise = axiosPost({
          url: 'service/delta/serviceobject/serviceObjectsProjects',
          data: bodyFormData,
          config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
          onSuccess: (response) => response.data.result,
          throws: true
        })
      }

      if (promise) {
        return promise.then(this.setProjectsOptions)
          .finally(() => {
            this.loadingProjects = false
          })
          .catch(response => {
            this.$q.notify({
              type: 'negative',
              message: response.message || 'Ошибка загрузки информации по проектам',
              progress: true,
              timeout: 8000
            })
          })
      }
    },
    setProjectsOptions: function (projectsOptions) {
      this.projectsOptions = projectsOptions

      if (this.requestFormConfiguration.projectAutoSubstitution && projectsOptions.length === 1) {
        this.request.project = projectsOptions[0]
      }
    },
    prepareDescription: function () {
      // this.descriptionOptionSelected = null
    },
    // setDescriptionOptions: function (descriptionOptions) {
    //   this.descriptionOptions = descriptionOptions
    //   if (descriptionOptions && descriptionOptions.length) {
    //     const defaultOption = descriptionOptions.find(opt => opt.default)
    //     this.descriptionOptionSelected = defaultOption || null
    //   } else {
    //     this.descriptionOptionSelected = null
    //   }
    // },
    // onSelectDescriptionOption: function (option) {
    //   this.descriptionOptionSelected = option
    //   if (!option.descriptionEditable) {
    //     this.request.description = option.name
    //   }
    // },
    onClose: function () {
      this.$emit('close')
    },
    onSuccessExecutorSelection: function () {
      this.$emit('success-executor-selection')
    },
    onCloseExecutorSelection: function () {
      EventBus.$emit('update-request', {})
      this.$emit('close-executor-selection')
    },
    resetParameters: function () {
      this.request = this.getNewRequest()
      this.createdRequests = []
      this.selectExecutorOpened = false
      this.availableWorkTypes = []
    },
    onSelectedWorkTypesIds: function (itemsIds) {
      this.request.selectedWorkTypesIds = itemsIds
    },
    loadActiveRequests: async function () {
      let requests = []
      this.loadingActiveRequests = true
      await loadObjectsActiveRequests(this.selectedServiceObjectsIds, this, false)
        .then(resultRequests => {
          requests = resultRequests || []
        })
        .finally(() => {
          this.loadingActiveRequests = false
        })

      this.activeRequests = requests
    },
    onShowActiveRequests: async function () {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        contentWidth: 1000,
        headerLabel: `Активные заявки (${this.activeRequests.length})`,
        contentComponent: RequestObjectActiveRequests,
        contentProps: {
          requests: this.activeRequests
        },
        componentHandlers: {
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    onCreateRequests: function () {
      if (!this.createRequestsAvailable) {
        return
      }

      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('serviceObjects', this.selectedServiceObjectsIds.join(','))
      bodyFormData.set('priority', this.request.requestPriority)
      bodyFormData.set('description', this.request.description)
      bodyFormData.set('autoAssign', this.request.autoAssign)
      bodyFormData.set('requestType', this.request.requestType)
      if (this.request.breakageTypeKey) {
        bodyFormData.set('breakageType', this.request.breakageTypeKey)
      }
      bodyFormData.set('source', this.request.requestSource ? this.request.requestSource.id : null)
      bodyFormData.set('workTypes', this.request.selectedWorkTypesIds)
      bodyFormData.set('works', JSON.stringify(this.request.workTypes))
      if (this.request.redirectWorkArea) {
        bodyFormData.set('redirectWorkArea', this.request.redirectWorkArea)
      }
      if (this.request.autoAssignBrigadeWorkTypes) {
        bodyFormData.set('autoAssignBrigadeWorkTypes', true)
      }
      bodyFormData.set('forkliftTruckRequired', !!this.request.forkliftTruckRequired)
      if (this.request.forkliftTruckRequired && this.request.requestForkliftTruck != null) {
        bodyFormData.set('requestForkliftTruck', this.request.requestForkliftTruck.id)
      }
      if (this.request.closeConditionTime) {
        bodyFormData.set('closeConditionTime', this.request.closeConditionTime)
      }
      if (this.request.project) {
        bodyFormData.set('project', this.request.project.id)
      }

      axiosPost({
        url: '/service/delta/targetProgram/generateRequests',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Заявки для объектов обслуживания успешно сгенерированы',
            progress: true,
            timeout: 3000
          })

          this.createdRequests = response.data.requests

          if (this.roleRestrictedOrExternalDispatcher) {
            EventBus.$emit('update-request', {})
            this.onClose()
          } else {
            if (this.createdRequests) {
              this.selectExecutorOpened = true
            }
          }
          EventBus.$emit('update-request-popup', {})
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response && response.message ? response.message : 'Ошибка при генерации заявок для объектов обслуживания',
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

